<template>
    <div name="card1" class="card">
        <span class="title">“인슐린 약국 지도에 우리동네 약국이 없어요"</span>
        <span class="description" style="margin-top: 20px;">전국 인슐린 약국 지도<br>5,000개 이상 확장</span>
        <img class="image" src="../../../../assets/improvement_4.png" />
        <div class="button" @click="go" style="margin-top: 62px;">
            자세히 보기
        </div>
    </div>
</template>

<script>
export default {
    name: 'card1',
    methods: {
        go: function()
        {
            window.open("https://blog.naver.com/soldoc_concierge/224313589936", "_blank")
        }
    }
}
</script>

<style scoped>
    .card {
        width: 702px;
        height: 260px;
        display: flex;
        flex-direction: column;
        padding: 32px 79.282px 32px 32px;
        border-radius: 18px;
        border: 1px solid var(--Gray-00, #FFF);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        position: relative;
    }
    .image {
        width: 159.718px;
        position: absolute;
        right: 0;
        bottom: 50px;
        right: 79.28px;
    }
    .title {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
    }
    .description{
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .button {
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 112.5% */
        width: 90px;
        height: 34px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/improvements/Card4.vue